import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Dashboard from '../pages/dashboard/Dashboard.vue'
// import List from '../components/table.vue'
import List from '../pages/list/index.vue'
import Add from '../pages/add/index.vue'
import Bill from '../pages/bill/index.vue'
import Cheque from '../pages/cheque/index.vue'
import Balances from '../pages/reports/balances/index.vue'
import Period from '../pages/reports/period/index.vue'
import Chart from '../pages/reports/charts/index.vue'
import Report from '../pages/reports/report/index.vue'
import Daily from '../pages/reports/daily/index.vue'
import BankBill from '../pages/bank_bill/index.vue'
import BankControl from '../pages/bank_control/index.vue'
import PrintLabelPdf from '../components/printLabelPdf'

import BankPrint from '../pages/bank_print/index.vue'
import BankPrintInternal from '../pages/bank_print/internal.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/login',
  name: 'login',
  component: Login
}, {
  path: '/',
  // name: 'home',
  component: Home,
  children: [{
      path: '',
      component: Dashboard
    }, {
      path: 'banks/page/:PageNum',
      component: List
    }, {
      path: 'banks/add',
      component: Add
    }, {
      path: 'banks/edit/:mid',
      component: Add
    }, {
      path: 'boxes/page/:PageNum',
      component: List
    }, {
      path: 'boxes/add',
      component: Add
    }, {
      path: 'boxes/edit/:mid',
      component: Add
    }, {
      path: 'boxes/bill/:PageNum',
      component: Bill
    }, {
      path: 'bank_accounts/page/:PageNum',
      component: List
    }, {
      path: 'bank_accounts/add',
      component: Add
    }, {
      path: 'bank_accounts/edit/:mid',
      component: Add
    }, {
      path: 'bank_accounts/bill/:PageNum',
      component: Bill
    }, {
      path: 'bank_accounts/report',
      component: Report
    }, {
      path: 'persons/page/:PageNum',
      component: List
    }, {
      path: 'persons/add',
      component: Add
    }, {
      path: 'persons/edit/:mid',
      component: Add
    }, {
      path: 'persons/bill/:PageNum',
      component: Bill
    }, {
      path: 'persons/lendingBill/:PageNum',
      component: Bill
    }, {
      path: 'products/page/:PageNum',
      component: List
    }, {
      path: 'products/add',
      component: Add
    }, {
      path: 'products/edit/:mid',
      component: Add
    }, {
      path: 'products/bill/:PageNum',
      component: Bill
    }, {
      path: 'products/report',
      component: Report
    }, {
      path: 'costs/page/:PageNum',
      component: List
    }, {
      path: 'costs/add',
      component: Add
    }, {
      path: 'costs/edit/:mid',
      component: Add
    }, {
      path: 'incomes/page/:PageNum',
      component: List
    }, {
      path: 'incomes/add',
      component: Add
    }, {
      path: 'incomes/edit/:mid',
      component: Add
    }, {
      path: 'users/page/:PageNum',
      component: List
    }, {
      path: 'users/add',
      component: Add
    }, {
      path: 'users/edit/:mid',
      component: Add
    }, {
      path: 'users/password/:mid',
      component: Add
    }, {
      path: 'roles/page/:PageNum',
      component: List
    }, {
      path: 'roles/add',
      component: Add
    }, {
      path: 'roles/edit/:mid',
      component: Add
    }, {
      path: 'roles/password/:mid',
      component: Add
    }, {
      path: 'fiscal_years/page/:PageNum',
      component: List
    }, {
      path: 'fiscal_years/add',
      component: Add
    }, {
      path: 'fiscal_years/edit/:mid',
      component: Add
    }, {
      path: 'invoices/page/:PageNum',
      component: List
    }, {
      path: 'invoices/add',
      component: Add
    }, {
      path: 'invoices/edit/:mid',
      component: Add
    }, {
      path: 'invoices/printLabel/:mid',
      component: PrintLabelPdf
    }, {
      path: 'invoices/report',
      component: Report
    }, {
      path: 'lendings/page/:PageNum',
      component: List
    }, {
      path: 'lendings/add',
      component: Add
    }, {
      path: 'lendings/edit/:mid',
      component: Add
    }, {
      path: 'lendings/printLabel/:mid',
      component: PrintLabelPdf
    }, {
      path: 'receipts/page/:PageNum',
      component: List
    }, {
      path: 'receipts/add',
      component: Add
    }, {
      path: 'receipts/edit/:mid',
      component: Add
    }, {
      path: 'payments/page/:PageNum',
      component: List
    }, {
      path: 'payments/add',
      component: Add
    }, {
      path: 'payments/edit/:mid',
      component: Add
    }, {
      path: 'transfers/page/:PageNum',
      component: List
    }, {
      path: 'transfers/add',
      component: Add
    }, {
      path: 'transfers/edit/:mid',
      component: Add
    }, {
      path: 'cheques/page/:PageNum',
      component: Cheque
    }, {
      path: 'balances/init',
      component: Balances
    }, {
      path: 'balances/current',
      component: Balances
    }, {
      path: 'reports/period',
      component: Period
    }, {
      path: 'reports/charts',
      component: Chart
    }, {
      path: 'reports/daily',
      component: Daily
    }, {
      path: 'bank_bill',
      component: BankBill
    }, {
      path: 'bank_control',
      component: BankControl
    },
    {
      path: 'bank_print',
      name: 'bankPrint',
      component: BankPrint
    },
    {
      path: 'bank_print_internal',
      name: 'bankPrintInternal',
      component: BankPrintInternal
    }
  ]
}, {
  // not found handler
  path: '*',
  redirect: '/'
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // console.log(to.path);
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = sessionStorage.getItem('auth');
  //
  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      // query: {
      //   returnUrl: to.path
      // }
    });
  }
  store.commit('SET_ROUTE', to);
  next();
})

export default router
